import React from 'react';
import { WelcomeBanner } from './components/WelcomeBanner';
import { DeveloperTools } from './components/DeveloperTools';
import { CorporateTools } from './components/CorporateTools';
import { UsefulLinks } from './components/UsefulLinks';

export const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Left Column - Main Content */}
          <div className="lg:col-span-2 space-y-6">
            <WelcomeBanner />

            <div className="grid grid-cols-1 gap-6">
              <DeveloperTools />
              <CorporateTools />
            </div>
          </div>

          {/* Right Column - Sidebar */}
          <div className="space-y-6">
            <UsefulLinks />

            {/* Merge Requests */}
            <div className="bg-white rounded-lg shadow p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">🔀 Merge Requests</h2>
                <a href="#" className="text-sm text-blue-600 hover:text-blue-800">Go To GitLab</a>
              </div>
              <table className="w-full">
                <thead className="text-xs text-gray-500 border-b">
                  <tr>
                    <th className="text-left pb-2">NAME, PROJECT</th>
                    <th className="text-left pb-2">CREATED</th>
                    <th className="text-left pb-2">UPDATED</th>
                    <th className="text-left pb-2">ROLE</th>
                  </tr>
                </thead>
                <tbody className="text-sm">
                  {/* Add sample data here */}
                </tbody>
              </table>
            </div>

            {/* Jira Issues */}
            <div className="bg-white rounded-lg shadow p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">📋 Jira Issues</h2>
                <a href="#" className="text-sm text-blue-600 hover:text-blue-800">Go To Jira</a>
              </div>
              <div className="text-center py-8 text-gray-500">
                <p>There are no issues to display</p>
                <p className="text-sm mt-2">Log in with your Jira credentials to upload issues</p>
                <button className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors">
                  Log In To Jira
                </button>
              </div>
            </div>

            {/* GitLab Issues */}
            <div className="bg-white rounded-lg shadow p-6">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">🦊 GitLab Issues</h2>
                <a href="#" className="text-sm text-blue-600 hover:text-blue-800">Go To GitLab</a>
              </div>
              {/* Add GitLab issues content here */}
            </div>

            {/* Favorites */}
            <div className="bg-white rounded-lg shadow p-6">
              <h2 className="text-xl font-semibold mb-4">⭐ Favorites</h2>
              <a href="#" className="text-sm text-blue-600 hover:text-blue-800">
                https://devportal.lseg.com/create/templates
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};